import { patterHeaderStyle, patternCellStyle } from '../../table/stylesReport';

export const columnsUsersPerRol = [
  {
    title: 'ROLES',
    field: 'name',
    width: null,
    defaultGroupOrder: 0,
    cellStyle: {
      ...patternCellStyle,
    },
    headerStyle: {
      ...patterHeaderStyle,
    },
  },
  {
    title: 'USERS',
    field: 'userName',
    width: null,
    cellStyle: {
      ...patternCellStyle,
    },
    headerStyle: {
      ...patterHeaderStyle,
    },
  },
  {
    title: 'CLIENTNAME',
    field: 'clientName',
    width: null,
    cellStyle: {
      ...patternCellStyle,
    },
    headerStyle: {
      ...patterHeaderStyle,
    },
  },
];
